export default async () =>
  await fetch(`/images/online.gif?${new Date().getTime()}`)
    .then(response => response.status >= 200 < 300)
    .catch(() => false);
